import { ROUTES } from "@/constants/routes";
import * as analytics from "@/utils/analytics";
import {
  appendSignupUtmParams,
  buildTemplateSignupParams,
  captureSignupUtm,
  parseSignupUtm,
  parseTemplateSignupIntent,
  stashTemplateSignupIntent,
} from "@cohesive/ui-components";

/**
 * Where Auth0 sends the visitor back: always the setup screen, which provisions
 * silently for whichever source applies. A fresh template intent and any
 * attribution ride inside the path, so the callback handler needs no knowledge
 * of them.
 */
export function signupReturnTo(search: string, now?: number): string {
  const intent = parseTemplateSignupIntent(search, now);
  const params =
    (intent ? buildTemplateSignupParams(intent) : null) ??
    new URLSearchParams();
  appendSignupUtmParams(params, parseSignupUtm(search));
  const query = params.toString();
  return query
    ? `${ROUTES.ONBOARDING.SETUP}?${query}`
    : ROUTES.ONBOARDING.SETUP;
}

/** Second copy of the intent, for the round trip that loses appState. */
export function beginTemplateSignup(search: string, now?: number): void {
  captureSignupUtm(search, now);

  const intent = parseTemplateSignupIntent(search, now);
  if (!intent) return;

  stashTemplateSignupIntent(intent);
  analytics.trackTemplateSignupStarted({
    kind: intent.kind,
    cta: intent.cta,
    id: intent.id,
  });
}
